module.exports = __webpack_public_path__ + "img/numberplateMotorbike.bc329911.svg";